/** Split a search box query into alphanumeric tokens. */
export function tokenizeSearchQuery(query) {
  return String(query || '')
    .toLowerCase()
    .trim()
    .split(/[^a-z0-9]+/i)
    .filter((token) => token.length > 0);
}

/**
 * True when every token appears somewhere in year/make/model/trim (and VIN/stock).
 * "Toyota Camry" and "Camry XSE" match a 2026 Toyota Camry XSE.
 */
export function vehicleMatchesSearch(vehicle, query, extraFields = []) {
  const tokens = tokenizeSearchQuery(query);
  if (!tokens.length) return true;
  const haystack = [
    vehicle?.year,
    vehicle?.make,
    vehicle?.model,
    vehicle?.trim,
    vehicle?.vin,
    vehicle?.stockNumber,
    vehicle?.body_type,
    vehicle?.exterior_color,
    ...extraFields,
  ]
    .filter((value) => value != null && String(value).trim() !== '')
    .join(' ')
    .toLowerCase();
  return tokens.every((token) => tokenInHaystack(token, haystack));
}

function tokenVariants(token) {
  const t = String(token || '').toLowerCase();
  if (!t) return [];
  const variants = [t];
  if (t.length > 4 && t.endsWith('es')) variants.push(t.slice(0, -2));
  if (t.length > 3 && t.endsWith('s') && !t.endsWith('ss')) variants.push(t.slice(0, -1));
  return variants;
}

function tokenInHaystack(token, haystack) {
  const hay = haystack || '';
  for (const variant of tokenVariants(token)) {
    if (variant && hay.includes(variant)) return true;
    if (variant.length >= 4) {
      for (const word of hay.split(/\s+/)) {
        if (
          (word.startsWith(variant) || variant.startsWith(word)) &&
          Math.min(word.length, variant.length) >= 4
        ) {
          return true;
        }
      }
    }
  }
  return false;
}
